<template>
  <el-dialog
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    v-loading="editProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View / Edit Custom Destination</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="editOperation">Save</el-button>
          <el-button type="default" @click="cancelOperation"> Cancel</el-button>
        </div>
      </div>
    </div>

    <el-form>
      <recent-audits
			service="Custom Destination" :record="selectedCustomDestination" />
      <div class="inline-form-group">
        <el-col :span="13">
          <el-input v-model="editForm.name" placeholder="Enter name">
            <template slot="prefix">Name</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="10">
          <DadsSelect
            v-model="editForm.ctId"
            placeholder="Select type"
            @change="onCustomTypeSelection"
            filterable
            clearable
          >
            <el-option
              v-for="(item, i) in customTypeOptions"
              :key="i"
              :label="item.label"
              :value="item.value"
            />
            <template slot="prefix">Type</template>
          </DadsSelect>
        </el-col>
      </div>

      <!-- FOR CUSTOM TYPE ALTERCALLERID (ct_id = 2) -->
      <div v-if="ctId === 2">
        <el-input v-model="editForm.param1" placeholder="Enter caller id name">
          <template slot="prefix">Caller id name</template>
        </el-input>
      </div>

      <!-- FOR CUSTOM TYPE CURL (ct_id = 34) -->
      <div v-if="ctId === 34">
        <h2 class="form-section-header">
          Request settings
        </h2>
        <div class="inline-form-group">
          <el-col :span="13">
            <el-input v-model="editForm.param1" placeholder="Enter URL">
              <template slot="prefix">URL</template>
            </el-input>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <el-select
              v-model="editForm.param2"
              placeholder="Select connection timeout"
            >
              <el-option
                v-for="(n, i) in 12"
                :key="i"
                :value="n * 5"
                :label="n * 5"
              />
              <template slot="prefix">Connection timeout</template>
            </el-select>
          </el-col>
        </div>

        <el-input
          v-model="editForm.param3"
          placeholder="Enter where to store result"
        >
          <template slot="prefix">Stored result in</template>
        </el-input>

        <el-input
          style="margin-top: 20px;"
          type="textarea"
          :rows="3"
          placeholder="Enter the post data"
          v-model="editForm.param4"
        />
      </div>

      <!-- FOR CUSTOM TYPE FORWARD (ct_id = 1) -->
      <div v-if="ctId === 1">
        <h2 class="form-section-header">
          Forward settings
        </h2>
        <div class="inline-form-group">
          <el-col :span="13">
            <el-select
              v-model="editForm.param1"
              filterable
              remote
              allow-create
              :remote-method="remoteSearchNums"
              placeholder="Enter phone number"
            >
              <el-option
                v-for="(item, i) in numOptions"
                :key="i"
                :label="numberFormatter(item.number)"
                :value="item.number"
              />
              <template slot="prefix">Phone number</template>
            </el-select>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <dads-select
              v-model="editForm.param2"
              filterable
              remote
              allow-create
              :remote-method="remoteSearchCidNums"
              placeholder="Enter caller id number"
            >
              <el-option
                v-for="(item, i) in callerIdNumOptions"
                :key="i"
                :label="item.label ? item.label : item.number"
                :value="item.value ? item.value : item.number"
              />
              <template slot="prefix">Caller id number</template>
            </dads-select>
          </el-col>
        </div>
        <div class="inline-form-group">
          <el-tag class="mb-10" type="warning">
            <i class="el-icon-warning" style="margin-right: 4px;"></i>
            Numbers should not contain special characters
          </el-tag>
        </div>
      </div>

      <!-- FOR CUSTOM TYPE PHONEBOOKLOOKUPDB (ct_id = 127) -->
      <div v-if="ctId === 127">
        <h2 class="form-section-header">
          Lookup settings
        </h2>
        <div class="inline-form-group">
          <el-col :span="13">
            <el-input v-model="editForm.param1" placeholder="Enter search term">
              <template slot="prefix">Search term</template>
            </el-input>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <DadsSelect
              v-model="editForm.param2"
              placeholder="Select phonebook"
            >
              <el-option
                v-for="(pb, i) in phonebookOptions"
                :key="i"
                :label="pb.name"
                :value="pb.id"
              />
              <template slot="prefix">Phonebook</template>
            </DadsSelect>
          </el-col>
        </div>
        <div class="inline-form-group">
          <el-tag class="mb-10" type="primary">
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Dialplan variables can be used here
          </el-tag>
        </div>
      </div>

      <!-- FOR CUSTOM TYPE QUEUEATPOSITION (ct_id = 30) -->
      <div v-if="ctId === 30">
        <h2 class="form-section-header">
          Settings
        </h2>
        <div class="inline-form-group">
          <el-tag class="mb-10 mt-10" type="primary">
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Leave queue empty to generally apply this rule
          </el-tag>
        </div>
        <div class="inline-form-group">
          <el-col :span="13">
            <DadsSelect
              placeholder="Select queue"
              filterable
              clearable
              v-model="editForm.param1"
            >
              <el-option
                v-for="(item, i) in queueOptions"
                :key="i"
                :label="item.name"
                :value="item.id"
              />
              <template slot="prefix">Queue</template>
            </DadsSelect>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <el-select
              placeholder="Select queue position"
              v-model="editForm.param2"
            >
              <el-option v-for="(n, i) in 20" :key="i" :value="n" :label="n" />
              <template slot="prefix">Queue position</template>
            </el-select>
          </el-col>
        </div>
      </div>

      <!-- FOR CUSTOM TYPE READVAR (ct_id = 24) -->
      <div v-if="ctId === 24">
        <h2 class="form-section-header">
          Variable settings
        </h2>
        <div class="inline-form-group">
          <el-col :span="13">
            <el-input
              v-model="editForm.param1"
              placeholder="Enter variable Name"
            >
              <template slot="prefix">Variable name</template>
            </el-input>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <el-select
              placeholder="Select max digits"
              v-model="editForm.param2"
            >
              <el-option v-for="(n, i) in 20" :key="i" :value="n" :label="n" />
              <template slot="prefix">Max digits</template>
            </el-select>
          </el-col>
        </div>

        <div class="inline-form-group">
          <el-col :span="13">
            <el-select placeholder="Select timeout" v-model="editForm.param3">
              <el-option
                v-for="(n, i) in 24"
                :key="i"
                :label="n * 5"
                :value="n * 5"
              />
              <template slot="prefix">Timeout</template>
            </el-select>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <el-select
              placeholder="Select loop count"
              v-model="editForm.param5"
            >
              <el-option v-for="(n, i) in 10" :key="i" :value="n" :label="n" />
              <template slot="prefix">Loop count</template>
            </el-select>
          </el-col>
        </div>
        <el-select v-model="editForm.param4" placeholder="Select audio message">
          <el-option
            v-for="(item, i) in mediafileOptions"
            :key="i"
            :label="item.name"
            :value="item.id"
          />
          <template slot="prefix">Audio message</template>
        </el-select>
      </div>

      <!-- FOR CUSTOM TYPE SETVAR (ct_id = 28) -->
      <div v-if="ctId === 28">
        <h2 class="form-section-header">
          Tag settings
        </h2>
        <div class="inline-form-group">
          <el-col :span="13">
            <el-select
              v-model="editForm.param1"
              placeholder="Select name"
            >
              <template slot="prefix">
                Tag name
              </template>
              <el-option value="tag1" label="tag1" />
              </el-select>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <el-input v-model="editForm.param2" placeholder="Tag value">
              <template slot="prefix">Tag value</template>
            </el-input>
          </el-col>
        </div>
        <div class="inline-form-group">
          <el-tag class="mb-10" type="primary">
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Dialplan variables can be used here
          </el-tag>
        </div>
      </div>


      <!-- FOR CUSTOM TYPE SEND TEXT MESSAGE (ct_id = 121)-->
      <div v-if="ctId === 121">
        <h2 class="form-section-header">
          Text message settings
        </h2>
        <div class="inline-form-group">
          <el-col :span="13">
            <el-input
              v-model="editForm.param1"
              placeholder="Enter to number"
            >
              <template slot="prefix">
                To number
              </template>
            </el-input>
          </el-col>
          <el-col :span="1" />
          <el-col :span="10">
            <el-input
              v-model="editForm.param2"
              placeholder="Enter from number"
            >
              <template slot="prefix">
                From number
              </template>
            </el-input>
          </el-col>
        </div>
        <div class="inline-form-group">
          <el-tag class="mb-10" type="warning">
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Enter 10 digit numbers with no special characters
          </el-tag>
        </div>
        <el-input
          type="textarea"
          :autosize="{minRows: 2}"
          v-model="editForm.param3"
          placeholder="Enter message"
        />
        <div class="inline-form-group">
          <el-tag class="mb-10" type="primary">
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Dialplan variables can be used here
          </el-tag>
        </div>
      </div>
    </el-form>
    <destination-references
      :tenantId="
        selectedCustomDestination ? selectedCustomDestination.tenantId : null
      "
      type="CUSTOM"
      :id="selectedCustomDestination ? selectedCustomDestination.id : null"
      :clearState="clearFormFields"
    />
  </el-dialog>
</template>

<script>
import DadsSelect from "@/components/select";
import DestinationReferences from "@/components/DestinationReferences";
import RecentAudits from '@/components/RecentAudits';
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "CustomDestinationEditForm",

  props: {
    editVisible: { required: true },
    clearFormFields: { required: true },
    editProcessing: { required: true },
    queueOptions: { required: true },
    numOptions: { required: true },
    cidNumOptions: { required: true },
    mediafileOptions: { required: true },
    phonebookOptions: { required: true },
    selectedCustomDestination: { required: true }
  },

  components: {
    DadsSelect,
    DestinationReferences,
    RecentAudits
  },

  data() {
    return {
      customTypeOptions: [
        {
          label: "Alter caller id",
          value: 2
        },
        {
          label: "Forward call to",
          value: 1
        },
        {
          label: "Send a text message",
          value: 121
        },
        {
          label: "Send call to queue at position",
          value: 30
        },
        {
          label: "Read a tag",
          value: 24
        },
        {
          label: "Route by previous call",
          value: 109
        },
        {
          label: "Tag a call",
          value: 28
        }
      ],
      editForm: {
        tenantId: null,
        ctId: null,
        name: "",
        param1: "",
        param2: "",
        param3: "",
        param4: "",
        param5: "",
        param6: ""
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    ctId() {
      return this.editForm.ctId;
    },

    callerIdNumOptions() {
      return [
        ...this.cidNumOptions,
        {
          label: "Use Original",
          value: "ORIGINAL"
        },
        {
          label: "Use Incoming DID",
          value: "INCOMINGDID"
        },
        {
          label: "Use PeerId Settings",
          value: "USEPEERID"
        }
      ];
    }
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    ctId(){
      if(this.ctId === 127){
        this.editForm.param1 = this.editForm.param1 ? this.editForm.param1 : '${USR-tag1}'
      }
    },

    selectedCustomDestination: {
      immediate: true,
      handler(val) {
        if (val) {
          const {
            ctId,
            name,
            param1,
            param2,
            param3,
            param4,
            param5,
            param6
          } = val;

          this.editForm.ctId = ctId;
          this.editForm.name = name;
          if (param1) {
            if (!isNaN(parseInt(param1))) {
              this.editForm.param1 = parseInt(param1);
            } else {
              this.editForm.param1 = param1;
            }
          }
          if (param2) {
            if (!isNaN(parseInt(param2))) {
              this.editForm.param2 = parseInt(param2);
            } else {
              this.editForm.param2 = param2;
            }
          }
          this.editForm.param3 = param3;
          if (param4) {
            this.editForm.param4 = JSON.parse(param4);
          }
          this.editForm.param5 = param5;
          this.editForm.param6 = param6;
        }
      }
    }
  },

  methods: {
    remoteSearchNums(query) {
      this.$emit("remoteSearchNums", query);
    },

    remoteSearchCidNums(query) {
      this.$emit("remoteSearchCidNums", query);
    },

    onCustomTypeSelection(type) {
      this.editForm.param1 = "";
      this.editForm.param2 = "";
      this.editForm.param3 = "";
      this.editForm.param4 = "";
      this.editForm.param5 = "";
      this.editForm.param6 = "";

      if (type === 1) {
        this.editForm.param3 = 30;
        this.editForm.param6 = "LEAVEASIS";
      }
    },

    editOperation() {
      this.editForm.tenantId = this.selectedTenant.id;
      let editBody = { ...this.editForm };

/*      if(editBody.ctId === 1){
        editBody.param1 = editBody.param1.replace(/['":;/{}()[|\-.,<>?_=+ \]]/g, '')
      }*/

      for (let i = 1; i < 7; i++) {
        editBody[`param${i}`] = editBody[`param${i}`].toString();
      }
      this.$emit("editOperation", editBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "edit");
    },

    clearFields() {
      this.editForm = {
        tenantId: null,
        ctId: null,
        name: "",
        param1: "",
        param2: "",
        param3: "",
        param4: "",
        param5: "",
        param6: ""
      };
    },

    numberFormatter(val) {
      return phoneNumberFormatter(val);
    },
  },

  filters: {
    formatNumber(value) {
      return parseInt(value)
        ? `(${value.substr(0, 3)}) ${value.substr(3, 3)}-${value.substr(6, 4)}`
        : value;
    }
  }
};
</script>
